<script setup>
import { getCurrentInstance } from 'vue';
import { APP } from "@/config/app"

defineProps({
  type: {
    type: String,
    default: 'submit',
  },
  value: String,
  isLoading: {
    type: Boolean,
    default: false
  },
  hasSvg: {
    type: Boolean,
    default: false
  }
});

//const instance = getCurrentInstance();
//console.log(instance.parent.isLoading);
</script>

<template>
  <button
    :type="type"
    :class="[
      'flex justify-center rounded-xl pb-3 pt-[8px] px-8 text-lg font-bold leading-6 text-white shadow-sm transform transition duration-300',
      { 'pt-2.5 pb-4 px-4' : hasSvg && !APP.MyWealthMode },
       APP.MyWealthMode ? 'primary-mwp' : 'primary-mwi'
    ]"
    :disabled="isLoading"
  >
    <svg v-if="isLoading" class="animate-spin mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
      <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
    </svg>

    <span
      v-if="value"
      :class="[ APP.MyWealthMode ? '' : 'text-teal dark:text-white']"
    >
      {{ value }}
    </span>

    <slot v-else />
  </button>
</template>
